import { forwardRef } from 'react';
import { SegmentFilterDisplayInfo } from 'src/shared/utils/SegmentFilterUtils';
import { Button, ButtonIcon, ButtonLabel, LoadingButton, LoadingIcon, LoadingLabel } from './styles';

export type CuisineButtonProps = {
  cuisineFilter: string;
  title: string;
  className?: string;
  isSelected?: boolean;
  onChange: (cuisineFilter: string) => void;
  rootCuisineFilter?: string;
  showInline?: boolean;
  underline?: boolean;
};

export const CuisineButton = forwardRef<HTMLButtonElement, CuisineButtonProps>((props, ref) => {
  const {
    cuisineFilter = '',
    isSelected = false,
    title,
    onChange,
    rootCuisineFilter = '',
    showInline,
    underline = false,
  } = props;
  const filterDisplayInfo = SegmentFilterDisplayInfo[cuisineFilter];
  const rootFilterDisplayInfo = SegmentFilterDisplayInfo[rootCuisineFilter ?? ''];
  const displayInfo = filterDisplayInfo ?? rootFilterDisplayInfo;

  return displayInfo ? (
    <Button
      onClick={() => onChange(cuisineFilter)}
      isSelected={isSelected}
      showInline={showInline}
      data-active={isSelected}
      ref={ref}>
      <ButtonIcon src={isSelected ? displayInfo.hoverIcon : displayInfo.icon} />
      <ButtonLabel isSelected={isSelected} showInline={showInline} underline={underline}>
        {title}
      </ButtonLabel>
    </Button>
  ) : null;
});

export const LoadingCuisineButton = () => (
  <LoadingButton>
    <LoadingIcon />
    <LoadingLabel />
  </LoadingButton>
);
